import { atomWithStorage } from "jotai/utils";
import type { UserDetails } from "./Interfaces/Auth";
import type { ReconStatus } from "./Interfaces/Recon";
import type { UIError } from "./Interfaces/Shared";

// sidebar
export const isSidebarCollapsed = atomWithStorage("isSidebarCollapsed", false);
export const isDrawerShown = atomWithStorage("isDrawerShown", true);

// auth
export const isAuthenticated = atomWithStorage("isAuthenticated", false);
export const userAtom = atomWithStorage<Partial<UserDetails> | null>(
  "userAtom",
  null
);

// recon status
export const reconStatus = atomWithStorage<ReconStatus | undefined>(
  "reconStatus",
  undefined
);

// error card
export const errorCardDetails = atomWithStorage<UIError>("errorCardDetails", {
  shown: false,
  title: "Error",
  message: "An error occurred. Please retry.",
});

// pending accounts view
export const pendingAccountsActiveView = atomWithStorage(
  "pendingAccountsActiveView",
  "tableView"
);
